/**
 * @file   : Link.js
 * @author : Amarjeet Lamba (Amarjeet.Lamba@AspiraConnect.com)
 * @date   : 4/15/2019, 8:32:40 PM
 */
import PropTypes from 'prop-types'
import React from 'react'

import Cont, {
  ALIGN_LEFT,
  ALIGN_RIGHT,
} from '../../../external/components/layout/Cont'
import Section from '../../../external/components/layout/Section'
import AIconAction, {
  ICON_POS_LEFT,
  ICON_POS_RIGHT,
} from '../../../external/components/link/AIconAction'
import { createSimpleLinkProps } from '../../../external/components/link/LinkUtils'
import { isEmpty } from '../../../external/utilities/GeneralUtils'
import { getTranslation } from '../InfoUtil'

const Link = ({ intl, theme, section, infoData, mainConfig }) => {
  const description = getTranslation(
    intl,
    section.description.token,
    section.description.default,
    infoData.infoToken,
  )
  if (section.showSection && !isEmpty(description) && !isEmpty(section.link)) {
    let faStyle = null
    let iconPos = null
    let align = ALIGN_LEFT
    if (section.linkType === 'forward') {
      faStyle = 'fa-arrow-right'
      iconPos = ICON_POS_RIGHT
      align = ALIGN_RIGHT
    } else if (section.linkType === 'back') {
      faStyle = 'fa-arrow-left'
      iconPos = ICON_POS_LEFT
    }

    return (
      <Cont align={align}>
        <AIconAction
          label={description}
          faStyle={faStyle}
          isShowAsLink
          iconPos={iconPos}
          {...createSimpleLinkProps(
            section.link,
            section.linkInternal,
            section.newWindow,
          )}
        />
        <Section />
      </Cont>
    )
  }

  return null
}

Link.propTypes = {
  intl: PropTypes.object.isRequired,
  theme: PropTypes.string.isRequired,
  section: PropTypes.object,
  infoData: PropTypes.object,
  mainConfig: PropTypes.object,
}

export default Link
